import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import { ProcessTypeEnum } from '../../constants/enums';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import {
  IAddProcess,
  IUpdateProcess,
} from '../../models/forms/IAddUpdateProcess';
import {
  IMultiSelectOption,
  IOption,
  IReactSelectOption,
} from '../../models/ICommon';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import {
  IProcessList,
  IProcessListVM,
  IProcessVM,
} from '../../models/response/IProcessResponse';
import { IProcessState } from '../../models/state/IProcessState';
import { formatMessage } from '../../translations/format-message';
import {
  AddUpdateDimensionInitialState,
  GetAllDimensionState,
  GetAllProcessState,
  GetDimensionInitialState,
  GetProcessState,
  ObservableInitialState,
} from '../initialState';
import * as baseService from '../service/base-service';
import { IAddProcessDimensionData } from '../../models/forms/IAddProcessDimensionData';
import {
  IDimensionDataItems,
  IProcessDimensionData,
} from '../../models/response/IProcessDimensionData';
import { da } from 'date-fns/locale';
import {
  IDimensionListVM,
  IDimensionVM,
  IDimensionItem,
} from '../../models/response/IDimensionResponse';
import { IDimensionState } from '../../models/state/IDimensionState';
import {
  IAddDimension,
  IUpdateDimension,
} from '../../models/forms/IAddDimension';
import viewTypeEnum from '../../constants/enums/view-type-enum';
import DimensionTypeEnum from '../../constants/enums/dimension-types';
const appConfig = config();

interface IColumnProps {
  ShortName: string;
  IsHidden: boolean;
}

export class DimensionStore implements IDimensionState {
  initialStateValue = ObservableInitialState;
  dimensionList: IDimensionListVM = GetAllDimensionState;
  dimension: any | undefined = undefined;
  getDimensionState = { ...this.initialStateValue };
  processDimension: IProcessDimensionData | undefined = undefined;
  dimensionByProcessIdList: IDimensionListVM | undefined = undefined;
  addUpdateDimensionState = { ...this.initialStateValue };
  getByDimensionIdState = { ...this.initialStateValue };
  deleteDimensionState = {...this.initialStateValue}

  constructor() {
    makeObservable(this, {
      dimension: observable,
      dimensionList: observable,
      reset: action,
      allDimension: computed,
      processDimension: observable,
      GetDimensionListService: action,
      dimensionByProcessIdList: observable,
      getDimensionState: observable,
      addUpdateDimensionState: observable,
      resetGetDimensionState: action,
      resetAddUpdateDimensionState: action,
      AddDimensionService: action,
      UpdateDimensionService: action,
      GetByDimensionIdService: action,
      getByDimensionIdState: observable,
      // dimensionDetails: computed,
      selectedProcesses: computed,
      resetDimensionDetail: action,
      DeleteDimensionService: action,
      deleteDimensionState: observable,
      resetDeleteDimensionState: action
    });
  }

  //#region Actions
  GetDimensionListService = (
    tenantId: number,
    PageSize: number,
    PageNo: number
  ) => {
    this.getDimensionState.inProgress = true;
    const url = `${URLConstants.GetDimensionList}/${tenantId}?PageSize=${PageSize}&PageNo=${PageNo}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IDimensionListVM>>) => {
        if (response.data.Error) {
          this.getDimensionState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.dimensionList = response.data.Data;
          this.getDimensionState.success = true;
        }
      })
      .catch((err: string) => {
        this.getDimensionState.error = err;
      })
      .finally(
        action(() => {
          this.getDimensionState.inProgress = false;
        })
      );
  };

  AddDimensionService = (data: IAddDimension) => {
    this.addUpdateDimensionState.inProgress = true;
    const url = URLConstants.AddDimension;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateDimensionState.error = response.data.Message;
        } else {
          this.addUpdateDimensionState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateDimensionState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateDimensionState.inProgress = false;
        })
      );
  };

  UpdateDimensionService = (data: IUpdateDimension) => {
    this.addUpdateDimensionState.inProgress = true;
    let url = URLConstants.AddDimension;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateDimensionState.error = response.data.Message;
        } else {
          this.addUpdateDimensionState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateDimensionState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateDimensionState.inProgress = false;
        })
      );
  };

  GetByDimensionIdService = (tenantId: number, dimensionId: number) => {
    this.getByDimensionIdState.inProgress = true;
    let url = `${URLConstants.GetByDimensionId}/${tenantId}?DimentionId=${dimensionId}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IDimensionVM>>) => {
        if (response.data.Error) {
          this.getByDimensionIdState.error = response.data.Message;
        } else {
          this.dimension = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.getByDimensionIdState.error = err;
      })
      .finally(
        action(() => {
          this.getByDimensionIdState.inProgress = false;
        })
      );
  };

  DeleteDimensionService = (tenantId: number,id: number) => {
    this.deleteDimensionState.inProgress = true;
    const url = `${URLConstants.DeleteDimension}?TenantId=${tenantId}&Id=${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteDimensionState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteDimensionState.success = true;
      })
      .catch((err: string) => {
        this.deleteDimensionState.error = err;
      })
      .finally(
        action(() => {
          this.deleteDimensionState.inProgress = false;
        })
      );
  };

  //#endregion

  //#region Computed

  get allDimension(): IDimensionItem[] {
    let processData: IDimensionItem[] = [];

    if (this.dimensionList?.DimensionItems?.length > 0) {
      this.dimensionList.DimensionItems.map((item, index) => {
        const processNames = item.Process
          ? item.Process.map(p => p.ProcessName).join(", ")
          : "";
        processData.push({
          Id: item.Id,
          Messages: item.Messages,
          ProcessName: processNames,
          Pixel: 0
        })

        // const processNames = item.Process
        //   ? item.Process.map(p => p.ProcessName).join(", ")
        //   : "";
        // processData.push({
        //   Id: item.Id,
        //   Messages: item.Messages,
        //   MessagesType: formatMessage(DimensionTypeEnum[item.MessagesType]),
        //   ProcessName: processNames,
        // });
      });
    }

    return processData;
  }

  get dimensionDetails(): IDimensionVM {
    if (this.dimension) {
      return {
        Process: this.dimension.Process,
        Id: this.dimension.Id,
        Messages: this.dimension.Messages,
        Pixel: this.dimension.Pixel,
      };
    }
    return {
      Id: -1,
      ...GetDimensionInitialState,
    };
  }

  get selectedProcesses(): any[] {
    let selectedProcesses: any[] = [];
    if (this.dimension && this.dimension.Process && this.dimension.Process.length > 0) {
      this.dimension.Process.map((process) => {
        selectedProcesses.push({
          Id: process.Id,
          MessageType: process.MessagesType,
          IsSelected: true,
        });
      });
    }
    return selectedProcesses;
  }

  //#endregion

  //#region Reset
  reset = () => {
    this.dimensionList = GetAllDimensionState;
  };

  resetGetProcessDimensionDataState = () => {
    this.getDimensionState = { ...this.initialStateValue };
  };

  resetGetDimensionState = () => {
    this.getDimensionState = { ...this.initialStateValue };
  };

  resetAddUpdateDimensionState = () => {
    this.addUpdateDimensionState = { ...this.initialStateValue };
  };

  resetDimensionDetail = () => {
    this.dimension = undefined;
    this.getByDimensionIdState = { ...this.initialStateValue }
  }

  resetDeleteDimensionState = () => {
    this.deleteDimensionState = {...this.initialStateValue}
  }
  //#endregion
}

export default new DimensionStore();
